module.exports = __webpack_public_path__ + "assets/media/drift-bolts.08903624.svg";